import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "total-damage" }
const _hoisted_2 = { class: "damage-name" }
const _hoisted_3 = { class: "total-damage-value" }
const _hoisted_4 = { class: "action-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "customized-result" }
const _hoisted_8 = { class: "category handle with-tooltip" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "tooltip" }
const _hoisted_11 = {
  class: "damage",
  style: {"vertical-align":"middle"}
}
const _hoisted_12 = { class: "damage-name" }
const _hoisted_13 = { class: "reaction-list" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "tooltip" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "tooltip" }
const _hoisted_20 = ["onUpdate:modelValue", "onChange"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "savedata" }
const _hoisted_23 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("fieldset", null, [
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.displayNameV("ローテーション合計ダメージ")), 1),
            _createElementVNode("td", _hoisted_3, _toDisplayString(Math.round(_ctx.totalDamage)), 1)
          ])
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.id
          }, [
            _createElementVNode("div", {
              class: "add-item",
              onClick: ($event: any) => (_ctx.addItem(item))
            }, [
              _createElementVNode("img", {
                class: _normalizeClass('action' + _ctx.itemImgClass(item)),
                src: item.src,
                alt: _ctx.displayName(item.name)
              }, null, 10, _hoisted_6)
            ], 8, _hoisted_5),
            _createElementVNode("div", null, _toDisplayString(_ctx.displayName(item.name)), 1)
          ]))
        }), 128))
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("table", _hoisted_7, [
        _createVNode(_component_draggable, {
          list: _ctx.rotationDamageCustomList,
          "item-key": "id",
          group: "action",
          sort: true,
          handle: ".handle"
        }, {
          item: _withCtx(({ element, index }) => [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_8, [
                _createElementVNode("img", {
                  class: _normalizeClass('action' + _ctx.itemImgClass(element)),
                  src: element.src,
                  alt: _ctx.displayName(element.name)
                }, null, 10, _hoisted_9),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.displayName(element.name)), 1)
              ]),
              _createElementVNode("td", _hoisted_11, [
                _createElementVNode("table", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDamageResultArr(element, _ctx.selectDamageResult(element)), (entry, index2) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index2 }, [
                      _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.displayNameV(entry[0])), 1),
                      _createElementVNode("td", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amplifyingReactionList(element, index2), (reaction) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "reaction with-tooltip",
                            key: reaction[0],
                            onClick: ($event: any) => (_ctx.reactionOnClick(element, index2, reaction))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.reactionCount(element, index2, reaction)), 1),
                            _createElementVNode("img", {
                              class: _normalizeClass('reaction' + _ctx.reactionUnselectedClass(element, index2, reaction)),
                              src: reaction[1],
                              alt: _ctx.displayName(reaction[0])
                            }, null, 10, _hoisted_15),
                            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.displayName(reaction[0])), 1)
                          ], 8, _hoisted_14))
                        }), 128))
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", {
                          class: "reaction with-tooltip",
                          onClick: ($event: any) => (_ctx.statChangeOnClick(element))
                        }, [
                          _createElementVNode("img", {
                            class: _normalizeClass('stat-change' + _ctx.statChangeUnselectedClass(element)),
                            src: _ctx.instructorImg,
                            alt: _ctx.displayName('教官')
                          }, null, 10, _hoisted_18),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.displayName('教官')), 1)
                        ], 8, _hoisted_17)
                      ]),
                      _createElementVNode("td", null, [
                        _cache[4] || (_cache[4] = _createTextVNode(" × ")),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((element.counts[index2]) = $event),
                          min: "0",
                          onChange: ($event: any) => (_ctx.countOnChange(element, index2))
                        }, null, 40, _hoisted_20), [
                          [_vModelText, element.counts[index2]]
                        ])
                      ]),
                      _createElementVNode("td", {
                        class: _normalizeClass('damage-value' + _ctx.elementColorClass(element, index2))
                      }, _toDisplayString(Math.round(_ctx.damageValue(element, index2))), 3)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (_ctx.doDelete(index))
                }, _cache[5] || (_cache[5] = [
                  _createElementVNode("span", { class: "material-symbols-outlined" }, " close ", -1)
                ]), 8, _hoisted_21)
              ])
            ])
          ]),
          _: 1
        }, 8, ["list"])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.savedataIndex) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedataList, (savedata) => {
          return (_openBlock(), _createElementBlock("option", {
            value: savedata[0],
            key: savedata[0]
          }, _toDisplayString(savedata[1]), 9, _hoisted_23))
        }), 128))
      ], 544), [
        [_vModelSelect, _ctx.savedataIndex]
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, "Save"),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
      }, "Remove")
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "notice" }, " 天賦アイコンまたは元素反応アイコンをクリックしてスキルローテーションを設定してください。 ", -1))
  ], 64))
}